import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

export const getWorkerInfoByPayload = (axios: IAxiosInstance) => {
  return async () => {
    const response = await axios.noRetry.get<
      ISchema["#/definitions/IGetWorkerInfoByPayloadResponse"]
    >(`/api/getWorkerInfoByPayload`, {
      params: { usePrimary: true },
    });
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
